import React, { useEffect, useState } from "react";

import WebIcon from "@mui/icons-material/Web";
import { Box, Grid, Tooltip } from "@mui/material";

import PropTypes from "prop-types";

import { useLeftBar } from "../../context/LeftBar";
import { Header } from "./components/Header";
import NavItem from "./MenuItem/NavItem";

import { ReactComponent as ArticlesOutlinedIcon } from "../../assets/icons/articles-outlined.svg";
import { ReactComponent as QuestionBoxIcon } from "../../assets/icons/question-box.svg";
import { ReactComponent as GridsOutlinedIcon } from "../../assets/icons/grids-outlined.svg";
import { ReactComponent as InsightsTimelineIcon } from "../../assets/icons/insights-timeline.svg";
import { ReactComponent as Sortimento } from "../../assets/icons/sortimento.svg";
import FormulaLogoFooter from "../../assets/img/logo-footer-execellence.png";

import styles from "../LeftSideMenu/styles.css";

import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      console.log("modificado:", reply);
      setDataAtualizacao(data.substring(0, 10));
    });
  }

  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();

  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="containerLeftSideMenu">
        <Header leftBarOpened={leftBarOpened} />

        <div className="leftSideClientContainer">
          {leftBarOpened && (
            <h2 className="titleSideCLient">CAMPANHA DE INCENTIVO</h2>
          )}
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent"
              : "leftSideContent leftSideContent-open"
          }
        >
          <ul>
            <NavItem
              muiIcon={<WebIcon />}
              name="Visão Geral"
              path="/overview"
            />

            <NavItem
              muiIcon={<GridsOutlinedIcon />}
              name="Detalhamento"
              path="/details"
            />

            <NavItem
              muiIcon={<InsightsTimelineIcon />}
              name="Oportunidades"
              path="/opportunities"
            />
          </ul>
        </div>

        {leftBarOpened && (
          <Grid
            flexDirection={"column"}
            alignItems={"flex-start"}
            columnGap={1}
            className="leftSideFooter"
          >
            <Grid item>
              <Box
                component={"img"}
                src={FormulaLogoFooter}
                className="container-img-leftSide"
              />
            </Grid>
            <Grid item>
              <p>Atualizado em: {dataAtualizacao}</p>
            </Grid>
          </Grid>
        )}
      </div>

      <div className="containerCloseSideMenu">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          {leftBarOpened ? (
            <ArrowBackIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#d33f00" }}
            />
          ) : (
            <ArrowForwardIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#d33f00" }}
            />
          )}
        </button>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
